import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_ARENDA_SINHROPEREVOD: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Иностранный спикер говорит в&nbsp;микрофон системы звукоусиления зала, звук которого поступает переводчикам в&nbsp;наушники',
            alt: 'Иностранный спикер говорит',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/foreign-speaker-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/foreign-speaker.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/foreign-speaker-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/foreign-speaker.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Управляя звуком с&nbsp;помощью пульта SPBAUDIO MAX, переводчики осуществляют синхронный перевод в&nbsp;головную гарнитуру, находясь в&nbsp;звукоизолированной кабине',
            alt: 'Управление звука с пульта SPBAUDIO MAX',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/simultaneous-interpretation-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/simultaneous-interpretation.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/simultaneous-interpretation-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/simultaneous-interpretation.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. Слушатель синхронно получает перевод выступления в&nbsp;свой наушник, благодаря беспроводной передаче сигнала из&nbsp;кабины на&nbsp;миниатюрный персональный приемник',
            alt: 'Синхронное получение перевода выступления в наушник',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/transfer-receipt-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/transfer-receipt.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/transfer-receipt-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/transfer-receipt.webp',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'А как в работе',
        description:
            'Процесс реальной работы переводчиков в&nbsp;кабине с&nbsp;пультом SPBAUDIO',
        width: 400,
        height: 224,
        video_preview:
            '/assets/images/usage/sinhroperevod/jpg-png/sinhroperevod-in-translation-booth-2.jpg',
        video_preview_webp:
            '/assets/images/usage/sinhroperevod/webp/sinhroperevod-in-translation-booth-2.webp',
        duration: '0:44',
        link: 'f98f49d76702c8b344866ee545e929c8',
    },
}

export default HOW_IT_WORK_ARENDA_SINHROPEREVOD
